import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { getLeadMatchQualityTier } from './helpers/leadMatchQuality';

const MatchQualityCell = memo(
    forwardRef((params, ref) => {
        const { data } = params;

        useImperativeHandle(ref, () => ({
            refresh: () => true,
        }));

        if (!data || data.status === 'failed') {
            return <span className="fm-leads-match-quality__empty">-</span>;
        }

        const tier = getLeadMatchQualityTier(data?.data?.scoreLead);
        if (!tier) {
            return <span className="fm-leads-match-quality__empty">-</span>;
        }

        return (
            <div
                className="fm-leads-match-quality"
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={tier.value}
            >
                <div className="fm-leads-match-quality__track">
                    <div
                        className={`fm-leads-match-quality__fill fm-leads-match-quality__fill--${tier.level}`}
                        style={{ width: `${tier.value}%` }}
                    />
                </div>
                <span className="fm-leads-match-quality__value">{tier.value}</span>
            </div>
        );
    }),
);

MatchQualityCell.displayName = 'MatchQualityCell';

export default MatchQualityCell;
